import { BaseElement, defineElement } from '@webtides/element-js';

export default class RecipeDetailPage extends BaseElement {
    wakeLock = null;

    events() {
        return {
            this: {
                'modal-open': async () => {
                    if (!('wakeLock' in globalThis.navigator)) return;
                    try {
                        this.wakeLock = await navigator.wakeLock.request('screen');
                    } catch (error) {
                        console.error('Error creating wake lock', error);
                    }
                },
                'modal-close': () => {
                    this.wakeLock?.release();
                    this.wakeLock = null;
                },
            },
        };
    }
}

defineElement('recipe-detail-page', RecipeDetailPage);
